import axios, { AxiosInstance } from 'axios';

import { Configuration } from 'src/Services/API/generated';

export enum LinkableEntityType {
  Task = 'task',
  Project = 'project',
  Contact = 'contact',
  VirtualFile = 'virtualFile',
  Expense = 'expense',
  CommunityFeedItem = 'communityFeedItem',
  Room = 'room',
  Event = 'event',
  InventoryItem = 'inventoryItem',
}

export enum LinkOrigin {
  Generic = 'GENERIC',
  Business = 'BUSINESS',
}

export interface LinkedEntityDto {
  linkId?: string;
  entityType: LinkableEntityType;
  entityId: string;
  title: string;
  subtitle?: string;
  linkOrigin: LinkOrigin;
  businessRelationKind?: string;
  metadata?: Record<string, unknown>;
  truncated?: boolean;
}

export interface CreateEntityLinkDto {
  sourceType: LinkableEntityType;
  sourceId: string;
  targetType: LinkableEntityType;
  targetId: string;
}

export class EntityLinksApi {
  private axiosInstance: AxiosInstance;
  private basePath: string;

  constructor(configuration: Configuration) {
    this.basePath = configuration.basePath ?? '';
    this.axiosInstance = axios.create({
      baseURL: this.basePath,
      ...configuration.baseOptions,
    });
  }

  async findAll(
    assetId: string,
    entityType: LinkableEntityType,
    entityId: string
  ): Promise<LinkedEntityDto[]> {
    const response = await this.axiosInstance.get<LinkedEntityDto[]>(
      `/assets/${assetId}/entity-links`,
      { params: { entityType, entityId } }
    );
    return response.data;
  }

  async create(assetId: string, data: CreateEntityLinkDto): Promise<LinkedEntityDto> {
    const response = await this.axiosInstance.post<LinkedEntityDto>(
      `/assets/${assetId}/entity-links`,
      data
    );
    return response.data;
  }

  async remove(assetId: string, linkId: string): Promise<void> {
    await this.axiosInstance.delete(`/assets/${assetId}/entity-links/${linkId}`);
  }
}
